import styled from 'styled-components';

export const IntroText = styled.p`
  font-family: 'Raleway', sans-serif;
  color: white;
  font-weight: 400;
  max-width: 550px;
  font-size: 18px;
  text-align: left;
  line-heigth: 1.6;
`;

export const HintText = styled.p`
  border-radius: 10px;
  background-color: rgba(87, 107, 122, .1);
  border: 0.5px solid #e2e8e6;
  padding: 1em;
  margin-bottom: 0.5em;
  font-family: 'Raleway', sans-serif;
  color: white;
  font-weight: 400;
  max-width: 550px;
  font-size: 18px;
  line-height: 1.6;
  text-align: left;
  margin-left: 10px;
  @media(max-width:  900px) {
    text-align: left;
  }
`;

export const HintWarningContainer = styled.div`
  background-color: yellow;
  color: black;
  padding: 60px;
  position: absolute;
`;

export const HintListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  max-height: 450px;
  @media (max-width: 900px) {
    max-height: none;
    overflow: auto;
  }
`;